module.exports = __webpack_public_path__ + "img/stage3.7d495f6b.png";